const _ = require('lodash');
const mapping = require('arbitrip-common/theme/mapping');
const DEFAULT_THEME_CONFIG_NAME = 'default'; //default arbitrip theme colors config

export const loadThemeConfig = async (company_id) => {
	const company_theme_name = _.get(mapping, company_id, DEFAULT_THEME_CONFIG_NAME);

	let themeConfigModule;
	try {
		themeConfigModule = await import(`arbitrip-common/theme/colors/configs/${company_theme_name}.json`);
	} catch (error) {
		console.error('Error loading theme configuration:', error);
		themeConfigModule = await import(`arbitrip-common/theme/colors/configs/${DEFAULT_THEME_CONFIG_NAME}.json`);
	}

	return themeConfigModule.default;
};

// Flattens config file and sets css variables
export const setCssVariables = (themeConfig, prefix = '') => {
	Object.entries(themeConfig).forEach(([key, value]) => {
		// Skip fonts section - it's handled separately
		if (key === 'fonts') {
			return;
		}
		if (typeof value === 'object' && value !== null) {
			// Recursive call for nested objects
			setCssVariables(value, `${prefix}${key}-`);
		} else {
			// Handle flat key-value pairs
			const cssVariableName = `--${prefix}${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
			document.documentElement.style.setProperty(cssVariableName, value);
		}
	});
};

// Loads custom fonts from theme config and injects @font-face declarations
export const loadThemeFonts = (themeConfig) => {
	// Remove any existing theme font stylesheet
	const existingStyle = document.getElementById('theme-fonts');
	if (existingStyle) {
		existingStyle.remove();
	}

	// If no fonts config, use fallback fonts
	if (!themeConfig?.fonts || !themeConfig.fonts.family || !themeConfig.fonts.files) {
		// Set CSS variables for fallback fonts
		document.documentElement.style.setProperty('--theme-font-family', 'Lato, Raleway, Open Sans, Roboto, sans-serif');
		document.documentElement.style.setProperty('--theme-main-font', 'Raleway');
		document.documentElement.style.setProperty('--theme-secondary-font', 'Lato');
		document.documentElement.style.setProperty('--theme-clean-font', 'Open Sans');
		return;
	}

	const { family, files } = themeConfig.fonts;

	// Generate @font-face declarations
	let fontFaceCSS = '';
	files.forEach((fontFile) => {
		const { path, weight = 400, style = 'normal' } = fontFile;
		fontFaceCSS += `
@font-face {
	font-family: '${family}';
	src: url('${path}') format('truetype');
	font-weight: ${weight};
	font-style: ${style};
	font-display: swap;
}
`;
	});

	// Inject CSS into document head
	const style = document.createElement('style');
	style.id = 'theme-fonts';
	style.textContent = fontFaceCSS;
	document.head.appendChild(style);

	// Set CSS variables for font family
	const fallbackFonts = 'Lato, Raleway, Open Sans, Roboto, sans-serif';
	document.documentElement.style.setProperty('--theme-font-family', `'${family}', ${fallbackFonts}`);
	document.documentElement.style.setProperty('--theme-main-font', `'${family}'`);
	document.documentElement.style.setProperty('--theme-secondary-font', `'${family}'`);
	document.documentElement.style.setProperty('--theme-clean-font', `'${family}'`);
};

const toCamelCase = (str) => {
	return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
};

// Helper function to recursively transform object keys to camelCase
export const transformKeys = (obj) => {
	if (obj !== null && typeof obj === 'object') {
		return Object.keys(obj).reduce(
			(acc, key) => {
				const camelCaseKey = toCamelCase(key);
				acc[camelCaseKey] = transformKeys(obj[key]); // Recursive call for nested objects
				return acc;
			},
			Array.isArray(obj) ? [] : {},
		);
	}
	return obj;
};
